import DeliveredOrder from '../../../Components/Order/DeliveredOrderDetails';

const DeliveredOrderDetails = () => {
  return (
    <div>
      <DeliveredOrder />
      {/* Additional NewOrder-specific UI */}
    </div>
  );
};

export default DeliveredOrderDetails;
